/*!

=========================================================
* Black Dashboard React v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardText,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
} from "reactstrap";

function UserProfile() {
  return (
    <>
      <div className="content">
        <Row>
          
          <Col md="8">
            <Card className="card-user">
              <CardBody>
                <CardText />
                <div className="author">
                  <div className="block block-one" />
                  <div className="block block-two" />
                  <div className="block block-three" />
                  <div className="block block-four" />
                  <a href="#pablo" onClick={(e) => e.preventDefault()}>
                    <img
                      alt="..."
                      className="avatar"
                      src={require("assets/img/steve.jpeg")}
                    />
                    <h5 className="title">Steve de Peijper</h5>
                  </a>
                  <p className="description">Creator of 'Iron Drive Stats'</p>
                </div>
                <div className="card-description">
                  I am a BI & Analytics engineer, owner of 'BI2Analytics' and cycling enthusiast. I created Iron Drive Stats to help cyclists and runners analyze their Strava data in a different way. I hope you enjoy using the app!
                <a href="https://www.linkedin.com/in/stevedep/" target="_blank"> Connect with me on LinkedIn</a>
                </div>
              </CardBody>
              <CardFooter>
              
              
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default UserProfile;
